import { PM_PROVIDERS } from 'common/constants/constants';
import useColorAssigner from 'common/hooks/colors/useColorAssigner';
import usePmProvider from 'components/hooks/PM/usePmProvider';
import { useEffect } from 'react';
import { RESOURCE_TYPES } from '../../resource_types';

const commonAssignedColors = {
  OTHERS: '#D8DEEA'
};

export const generateResourceColorKey = (resourceTypeKey, colorKey) => {
  const commonAssignedColorsKeys = Object.keys(commonAssignedColors).map(key =>
    key.toLowerCase()
  );
  const isCommon = commonAssignedColorsKeys.includes(colorKey.toLowerCase());

  return isCommon ? colorKey : `${resourceTypeKey}.${colorKey}`;
};

const mapAssignedColorsByPmProvider = {
  [PM_PROVIDERS.JIRA]: {
    [RESOURCE_TYPES.JIRA_ISSUE_TYPES.key]: {
      BUG: '#FDA23E',
      STORY: '#9DDD88',
      TASK: '#2C6CB0',
      SUBTASK: '#56ACE5',
      EPIC: '#852F7A'
    }
  },
  [PM_PROVIDERS.AZURE_BOARDS]: {
    [RESOURCE_TYPES.AZURE_WORK_ITEMS.key]: {
      BUG: '#CC293D',
      ISSUE: '#FF8C00',
      IMPEDIMENT: '#AC98FF',
      'PRODUCT BACKLOG ITEM': '#1E90FF',
      'TEST CASE': '#3B5998',
      'USER STORY': '#4EC3E0'
    }
  }
};

const useRaColorAssigner = () => {
  const colorAssigner = useColorAssigner();
  const pmProvider = usePmProvider();

  const initColorAssigner = () => {
    Object.entries(commonAssignedColors).forEach(([key, color]) =>
      colorAssigner.setKeyColor(key, color)
    );

    const pmAssignedColors = mapAssignedColorsByPmProvider[pmProvider] || {};
    Object.keys(pmAssignedColors).forEach(resourceTypeKey => {
      Object.entries(pmAssignedColors[resourceTypeKey]).forEach(
        ([key, color]) => {
          const colorKey = generateResourceColorKey(resourceTypeKey, key);
          colorAssigner.setKeyColor(colorKey, color);
        }
      );
    });
  };

  useEffect(() => {
    initColorAssigner();
  }, []);

  return colorAssigner;
};

export default useRaColorAssigner;
